import React, { useEffect, useRef, createElement } from 'react';
import { motion } from 'framer-motion';
const BookingPage = () => {
  const calendarRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    // Load Calendly script
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return <main className="flex-grow bg-black min-h-screen" data-id="element-401">
      {/* Header Section */}
      <div className="w-full py-6 sm:py-10 px-3 sm:px-6 md:px-8" data-id="element-402">
        <div className="max-w-4xl mx-auto text-center" data-id="element-403">
          {/* Logo */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7
        }} className="mb-4 sm:mb-6" data-id="element-404">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/iEuzHiZoD7HHWbnpRvvh2M/516lion.png" alt="516 Partners Logo" className="mx-auto w-16 sm:w-20 md:w-24" data-id="element-405" />
          </motion.div>

          {/* Headline */}
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: 0.2
        }} className="text-white text-xl sm:text-3xl md:text-4xl lg:text-5xl mb-2 sm:mb-3 typekit-heading leading-tight px-1 sm:px-2" data-id="element-406">
            Congrats! You're qualified for a complimentary{' '}
            <span className="text-[#ffdf07]" data-id="element-407">Cash & Capital Consult</span>
          </motion.h1>

          {/* Subheadline */}
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: 0.3
        }} className="libre-caslon-text-regular text-sm sm:text-lg text-gray-300 mb-6 sm:mb-8 leading-relaxed px-1 sm:px-2" data-id="element-408">
            Book your call below (may take a few seconds to load)
          </motion.p>
        </div>
      </div>

      {/* Calendly Widget - Full Width, No Container */}
      <motion.div ref={calendarRef} initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.7,
      delay: 0.4
    }} className="w-full" data-id="element-409">
        <div className="calendly-inline-widget" data-url="https://calendly.com/ivan-516partners/sprintconsult" style={{
        minWidth: '320px',
        height: '700px'
      }} data-id="element-410"></div>
      </motion.div>
    </main>;
};
export default BookingPage;